import { httpClient } from './http-client';
import type { ApiResponse, PaginatedResponse } from './api.types';
import type { Notificacion, NotificacionSinLeer } from '@/modelos/notificaciones/notificacion.types';

export const notificacionesService = {
  getAll: (page = 1, pageSize = 20): Promise<ApiResponse<PaginatedResponse<Notificacion>>> =>
    httpClient.get('/notificaciones', { page, pageSize }),

  getSinLeerCount: (): Promise<ApiResponse<NotificacionSinLeer>> =>
    httpClient.get('/notificaciones/sin-leer/count'),

  marcarLeida: (id: string): Promise<ApiResponse<boolean>> =>
    httpClient.patch(`/notificaciones/${id}/marcar-leida`),

  marcarTodasLeidas: (): Promise<ApiResponse<number>> =>
    httpClient.patch('/notificaciones/marcar-todas-leidas'),
};
